import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

import { getLocaleFromPath } from './getLocaleFromPath'

/**
 * Replaces the locale in a URL path, or inserts it if not present.
 *
 * @param path - The original URL pathname (e.g., "/fr-fr/products")
 * @param newLocale - The new locale to apply (e.g., "en-us")
 * @returns A pathname with the locale replaced or prepended (e.g., "/en-us/products")
 */
export const replaceLocaleInPath = (
  path: string,
  newLocale: Bcp47Locale,
): string => {
  const currentLocale = getLocaleFromPath(path)

  if (currentLocale) {
    return path.replace(`/${currentLocale}`, `/${newLocale}`)
  }

  return `/${newLocale}${path}`
}
